function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.61 10.83a5.237 5.237 0 00-2.91-1.78c-.26-1.16-.71-2.16-1.37-2.99a.555.555 0 00-.06-.08c-2.2-2.66-5.8-2.65-8.23-1.27-2.08 1.19-3.85 3.7-2.92 7.28-2.13.52-3.11 2.38-3.11 4.06 0 1.88 1.23 3.99 3.97 4.19h10.38c1.42 0 2.78-.53 3.83-1.49 2.51-2.22 2.18-5.84.42-7.92z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.76 8.74c0 .9-.32 1.76-.9 2.42-.07-.11-.16-.22-.25-.33a5.204 5.204 0 00-2.91-1.78c-.25-1.16-.71-2.15-1.37-2.98-.01-.03-.04-.06-.06-.08-.1-.12-.21-.23-.31-.34.61-.42 1.31-.64 2.07-.64a3.73 3.73 0 013.73 3.73z"
})));